export default __webpack_public_path__ + "static/reward_banner-402753c445a120ea7c9985941d221e38.png";